export const getTrackingKey = (uri = '', postFix = '') => {
  return `${(uri ?? '').substring(1).replace('/', '_')}${
    postFix ? '_' + postFix : ''
  }`
}
